
import { Participant } from "@/api/dtos";
import useParticipantSourceDataFormStatuses from "@/hooks/data/useParticipantSourceDataFormStatuses";
import useParticipants from "@/hooks/data/useParticipants";
import useSourceData from "@/hooks/data/useSourceData";
import { createContext } from "react"

export interface IParticipantSourceDataFormStatusesContext extends ReturnType<typeof useParticipantSourceDataFormStatuses> {
}

export const ParticipantSourceDataFormStatusesContext = createContext<IParticipantSourceDataFormStatusesContext>({
    data: undefined,
    idMap: {},
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default ParticipantSourceDataFormStatusesContext;